// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from 'reactstrap';
import {
  AvField,
  AvInput,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  getRegionUrl,
} from 'common.helpers/dist/browser';
import config from '../../../config';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'CustomPage'> | $ModelUpsertParams<'CustomPage'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const CustomPageFieldsView = function ({
  item,
  main,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={4}>
          <InputDoubleButton
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col xs={8}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>{t('Page address')}</Label>
          <InputGroup className={'mb-2'}>
            <InputGroupText>
              {getRegionUrl({
                mainDomain: config.DOMAIN,
                RegionId: item.RegionId,
                regions: main.regions,
              })}
            </InputGroupText>
            <AvInput
              name={'Slug'}
              value={item.Slug}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Content')}
            name={'Content'}
            required
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Region')}
            name={'RegionId'}
            required
            type={'select'}
            value={item.RegionId}
          >
            {_.map(
              main.regions,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default CustomPageFieldsView;
